<script setup lang="ts">
import { useRouter } from 'vue-router';

import { useI18n } from '@/references/i18n';
import { RouteNames } from '@/router';

import BeneficiarySelector from '@/components/BeneficiarySelector.vue';
import UiContainer from '@/components/ui/UiContainer.vue';
import UiTitle from '@/components/ui/UiTitle.vue';

const { push } = useRouter();
const { t } = useI18n();

function onBeneficiarySelected(id: number) {
  push({ name: RouteNames.OTC, params: { id } });
}
</script>

<template>
  <section class="home-info">
    <UiContainer class="home-info__container">
      <div class="home-info__body">
        <UiTitle :level="1" class="home-info__title">
          {{ t('home.title') }}
        </UiTitle>
        <BeneficiarySelector @select="onBeneficiarySelected" />
      </div>
    </UiContainer>
  </section>
</template>

<style scoped>
.home-info {
  position: relative;
  margin: -40px 0;
}

@media (max-width: 1279px) {
  .home-info {
    margin: 0;
  }
}

.home-info__container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  transition: max-width var(--animation-micro) var(--animation-micro) var(--animation-effect);
}

@media (min-width: 1280px) {
  .home-info_opened .home-info__container {
    max-width: 1080px;
    transition: max-width var(--animation-micro) var(--animation-effect);
  }
}

.home-info__body {
  min-width: 560px;
  max-width: 560px;
  padding: 40px 0;
  transition:
    max-width var(--animation-micro) var(--animation-micro) var(--animation-effect),
    min-width var(--animation-micro) var(--animation-micro) var(--animation-effect),
    opacity var(--animation-micro) var(--animation-effect);
}

@media (max-width: 1319px) {
  .home-info_opened .home-info__body {
    min-width: 500px;
    max-width: 500px;
    transition:
      max-width var(--animation-micro) var(--animation-effect),
      min-width var(--animation-micro) var(--animation-effect);
  }
}

@media (max-width: 1279px) {
  .home-info .home-info__body {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    padding: 0;
    transition: none;
  }
}

.home-info__body:not(:last-child) {
  margin: 0 40px 0 0;
}

.home-info__title {
  margin: 0 0 24px;
}

@media (max-width: 919px) {
  .home-info__title {
    display: none;
  }
}
</style>
